<template>
	<div class="p-404">
		<h1>{{ $t("system.NotFound") }}</h1>
	</div>
</template>

<script>
export default {
	name: 'p-404'
}
</script>



// WEBPACK FOOTER //
// src/pages/p-404.vue